
  // Función para mover las etiquetas “sale”
  function moveSaleTags() {
    document.querySelectorAll('.m-product-card').forEach(product => {
      const tag = product.querySelector('.m-product-tag--sale');
      const saleDiv = product.querySelector('.m-price__sale');
      if (tag && saleDiv && tag.parentNode !== saleDiv) {
        saleDiv.appendChild(tag);
      }
    });
  }

  // Espera a que el DOM esté listo
  document.addEventListener('DOMContentLoaded', () => {
    moveSaleTags();

    // Si tu carrusel es Splide (Minimog suele usar Splide):
    document.querySelectorAll('.splide').forEach(splideEl => {
      splideEl.addEventListener('mounted', moveSaleTags);
      splideEl.addEventListener('moved', moveSaleTags);
    });

    // En caso de carga dinámica sin eventos específicos, usa un MutationObserver:
    const observer = new MutationObserver(moveSaleTags);
    observer.observe(document.body, { childList: true, subtree: true });
  });
